import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@yooga-tecnologia/mantra/loader';
import { register as registerSwiper } from 'swiper/element/bundle';

registerSwiper();

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

defineCustomElements();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
